<div class="modal-content add-dialog" style="padding: 10px;">
    <div class="modal-header" style="display: block;">
        <div style="width: 100%; height: 30px;">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                (click)="modal.dismiss(false)">&times;</button>
        </div>
        <h5 class="modal-title" id="exampleModalLongTitle" style="text-align: center;">{{title}}</h5>
    </div>
    <div class="modal-body">
        <p>{{bodyText}}</p>
        <input class="form-control input" type="text" placeholder="{{ 'Machinenumber' | translate }}"
            [(ngModel)]="inpMachinenumber" (keydown.enter)="onEnter()" (click)="$event.stopPropagation()" />
    </div>
    <div class="modal-footer">
        <button type="button" style="margin-right: auto; border: none;" class="btn btn-outline-secondary"
            (click)="modal.dismiss(false)">{{ 'Cancel' | translate }}</button>
        <button type="button" class="button btn-poettinger" (click)="exitModal()">{{ 'confirmInput' | translate
            }}</button>
    </div>
</div>